import { Link } from "react-router-dom";
import { SiteFooter } from "../components/SiteFooter";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_da98dbcd-f751-4482-bd4e-a7e20426ba71/artifacts/tm6wbpvj_CD8D187A-3FEA-430F-A897-685C7F8A2178.png";

export default function TermsPage() {
  return (
    <div className="min-h-screen flex flex-col" style={{ background: "var(--bg-primary)" }} data-testid="terms-page">
      <div className="px-6 md:px-12 py-8 border-b" style={{ borderColor: "var(--border)" }}>
        <Link to="/"><img src={LOGO_URL} alt="Green Routes" className="h-8 md:h-10 mx-auto logo-blend" /></Link>
      </div>

      <div className="flex-1 max-w-3xl mx-auto px-6 py-12 md:py-16">
        <p className="text-xs tracking-[0.2em] uppercase mb-4 font-semibold" style={{ color: "var(--text-tertiary)" }}>Legal</p>
        <h1 className="text-3xl sm:text-4xl tracking-tight mb-3" style={{ color: "var(--text-primary)" }}>Terms &amp; Conditions</h1>
        <p className="text-sm mb-10" style={{ color: "var(--text-tertiary)" }}>Last updated: August 2026</p>

        <div className="space-y-8 text-sm leading-relaxed" style={{ color: "var(--text-secondary)" }}>
          <section>
            <h2 className="text-lg mb-3" style={{ color: "var(--text-primary)" }}>1. Agreement to Terms</h2>
            <p>By accessing or using the Green Routes Consulting website and services (the &ldquo;Services&rdquo;), you agree to be bound by these Terms and Conditions. If you do not agree, do not use the Services. These Terms apply to all visitors, users, and clients.</p>
          </section>

          <section>
            <h2 className="text-lg mb-3" style={{ color: "var(--text-primary)" }}>2. Services Description</h2>
            <p>Green Routes Consulting provides cannabis supply chain consulting services, including sourcing introductions, route analysis, and concierge coordination. All introductions and sourcing are conducted in compliance with applicable state and local regulations. We act solely as consultants and intermediaries; we do not sell, distribute, or handle any controlled substances.</p>
          </section>

          <section>
            <h2 className="text-lg mb-3" style={{ color: "var(--text-primary)" }}>3. Eligibility</h2>
            <p>You must be at least 21 years of age and legally authorized to engage in cannabis-related commerce in your jurisdiction to use our Services. By using the Services, you represent and warrant that you meet these requirements.</p>
          </section>

          <section>
            <h2 className="text-lg mb-3" style={{ color: "var(--text-primary)" }}>4. Consultation Fees &amp; Payments</h2>
            <p>Consultation fees are charged at the time of booking and are non-refundable. Payment is processed securely through Stripe. Prices are as listed on the platform at the time of purchase. Extended session fees may apply if consultations exceed their allotted time. Concierge packages require a deposit with the remaining balance due before the trip.</p>
          </section>

          <section>
            <h2 className="text-lg mb-3" style={{ color: "var(--text-primary)" }}>5. Private Access &amp; Approval</h2>
            <p>Certain services, including direct cultivator access, are approval-based. Submission of an application and payment does not guarantee approval. Denied applicants will be offered alternative service tiers or guidance as appropriate.</p>
          </section>

          <section>
            <h2 className="text-lg mb-3" style={{ color: "var(--text-primary)" }}>6. Intellectual Property</h2>
            <p>All content on this site, including text, graphics, logos, and software, is the property of Green Routes Consulting and is protected by applicable intellectual property laws. You may not reproduce, distribute, or create derivative works without our prior written consent.</p>
          </section>

          <section>
            <h2 className="text-lg mb-3" style={{ color: "var(--text-primary)" }}>7. Limitation of Liability</h2>
            <p>Green Routes Consulting shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of the Services. Our total liability shall not exceed the amount paid by you for the specific service giving rise to the claim. We do not guarantee any particular outcome from consultations or introductions.</p>
          </section>

          <section>
            <h2 className="text-lg mb-3" style={{ color: "var(--text-primary)" }}>8. Confidentiality</h2>
            <p>All information shared during consultations, including cultivator identities, pricing, and sourcing strategies, is strictly confidential. Unauthorized disclosure of confidential information may result in termination of services and legal action.</p>
          </section>

          <section>
            <h2 className="text-lg mb-3" style={{ color: "var(--text-primary)" }}>9. Modifications</h2>
            <p>We reserve the right to modify these Terms at any time. Changes will be posted on this page with an updated date. Continued use of the Services after changes constitutes acceptance of the revised Terms.</p>
          </section>

          <section>
            <h2 className="text-lg mb-3" style={{ color: "var(--text-primary)" }}>10. Contact</h2>
            <p>For questions about these Terms, contact us at <a href="mailto:Greenroutesconsulting@gmail.com" style={{ color: "var(--primary)", fontWeight: 500 }}>Greenroutesconsulting@gmail.com</a> or <a href="https://buy.stripe.com/test_3cI3cw76afo3dj8ekM2cg00" target="_blank" rel="noopener noreferrer" style={{ color: "var(--primary)", fontWeight: 500 }}>book a consultation</a>.</p>
          </section>
        </div>
      </div>

      <SiteFooter />
    </div>
  );
}
